import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import frJSON from "../locale/fr.json"

i18n.use(initReactI18next).init({
    resources: {
        fr: { ...frJSON }
    },
    lng: "fr",     // Set the initial language of the App
});